/**
 * Format currency in EUR for de-AT locale
 */
export function formatCurrency(cents: number): string {
  const euros = cents / 100
  return new Intl.NumberFormat('de-AT', {
    style: 'currency',
    currency: 'EUR',
  }).format(euros)
}
